import { isEmpty } from 'lodash'
import React, { useMemo } from 'react'
import { PerformanceIndicatorsViewByType } from 'scenes/Dashboard/components/PerformanceIndicatorsOfTypeView/PerformanceIndicatorsViewByType.component'
import { getUniqueTypes } from 'scenes/Dashboard/data/performanceIndicators/helpers'
import { PerformanceIndicator, PerformanceIndicatorType } from 'scenes/Dashboard/data/performanceIndicators/types'
import { makeStyles } from 'tss-react/mui'

import { List, Theme } from '@mui/material'

import SectionHeader from '../SectionHeader'
import { OtherTractionMetrics } from './components/OtherTractionMetrics'

type PerformanceIndicatorsViewListProps = {
  performanceIndicators: PerformanceIndicator[]
  otherTractionMetrics?: string
}

export const PerformanceIndicatorsViewList = ({
  performanceIndicators,
  otherTractionMetrics,
}: PerformanceIndicatorsViewListProps) => {
  const { classes } = useStyles()
  const performanceIndicatorsTypes = useMemo(() => getUniqueTypes(performanceIndicators), [performanceIndicators])
  if (isEmpty(performanceIndicators)) {
    return null
  }
  return (
    <section className={classes.container}>
      <SectionHeader text="Performance Indicators" />
      <List dense>
        {performanceIndicatorsTypes.map((type) => (
          <PerformanceIndicatorsViewByType
            key={type}
            performanceIndicators={performanceIndicators}
            type={type}
            dateFormat={getDateFormat(type)}
          />
        ))}
      </List>
      {otherTractionMetrics && <OtherTractionMetrics otherTractionMetrics={otherTractionMetrics} />}
    </section>
  )
}

function getDateFormat(type: PerformanceIndicatorType) {
  switch (type) {
    case PerformanceIndicatorType.committedInvestors:
    case PerformanceIndicatorType.otherTraction:
    case PerformanceIndicatorType.committedCapital:
      return 'yyyy/MM/dd'
    default:
      return 'yyyy/MM'
  }
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    marginBottom: spacing(2),
    marginTop: spacing(2),
  },
}))
